import { isAfter } from 'date-fns';

const handleDateTimeBasedScheduled = ({ entity, now }) => {
  if (entity == null || entity.saleStartOn == null) {
    return { isScheduled: false, hasInvalidReference: false };
  }

  const saleStartOn = new Date(entity.saleStartOn);

  return { isScheduled: isAfter(saleStartOn, now), hasInvalidReference: false };
};

export default handleDateTimeBasedScheduled;
